module.exports = __webpack_public_path__ + "static/media/fr20minuteslogo.34093556.png";